import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ReloadReplayVideoIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M0 9.49333H9.04061L5.38703 5.73333C9.02728 2.13333 14.921 2 18.5613 5.6C22.2015 9.21333 22.2015 15.04 18.5613 18.6533C14.921 22.2667 9.02728 22.2667 5.38703 18.6533C3.57358 16.8667 2.66685 14.7733 2.66685 12.1333H0C0 14.7733 1.17341 18.2 3.52024 20.52C8.20055 25.16 15.8011 25.16 20.4814 20.52C25.1484 15.8933 25.1884 8.37333 20.5081 3.74667C15.8277 -0.88 8.32056 -0.88 3.64024 3.74667L0 0V9.49333Z"
            fill="#222"
          />
          <path
            d="M10.2409 15.3756L16.1643 12.5054C16.2121 12.482 16.2511 12.4452 16.2761 12.3962C16.3326 12.277 16.2859 12.1333 16.1697 12.0731L10.2452 9.02572C10.0878 8.94439 9.90002 9.06138 9.90002 9.24077V15.1561C9.90002 15.1929 9.90871 15.2285 9.9239 15.2608C9.98035 15.3823 10.1225 15.4324 10.2409 15.3756Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
